import { api } from "..";


export const getNotificationConfig = async (companyId) => {
  const response = await api.get(`/api/ShipmentNotification/config/${companyId}`);
  return response.data;
};

export const saveNotificationConfig = async (config) => {
  const response = await api.post('/api/ShipmentNotification/config', config);
  return response.data;
};

export const sendTestNotification = async (companyId, emailRecipients) => {
  const response = await api.post('/api/ShipmentNotification/test', {
    companyId,
    emailRecipients
  });
  return response.data;
};
